export const MRMRequestType = {
  CREATE: "CREATE",
  DELETE: "DELETE",
  NO_REQUEST: "NO_REQUEST",
}
export const REMARK_REQUEST_STATUS = {
  ACCEPT: "ACCEPT",
  REJECT: "REJECT",
};
export const STATUS = {
  TERMINATED: "TERMINATED",
  PENDING: "PENDING",
};
